import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5H12.75V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.9685 19.5935 17.375 16.625 17.375C13.6565 17.375 11.25 14.9685 11.25 12V11.25H12.75V12C12.75 14.1401 14.4849 15.875 16.625 15.875C18.7651 15.875 20.5 14.1401 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircle;
